module.exports = __webpack_public_path__ + "static/media/james3.c6530283.mp3";